import React, { useState, useEffect, useRef } from "react"
import { Manager, Reference, Popper } from "react-popper"
import { FunctionComponent } from "react"
import SVG from "react-inlinesvg"

import infoSVG from "../../../../priv/static/svg/generic/info.svg"

// Hook that handles clicks outside of the passed ref
function bindOutsideEvent(ref: React.RefObject<HTMLDivElement>, setVisible: React.Dispatch<React.SetStateAction<boolean>>) {
  function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      setVisible(false)
    }
  }

  useEffect(() => {
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside)
    }
  })
}

interface InfoTooltipProps {
  children: any
  content?: string
  svgIcon?: any
  iconClassName?: string
}

const InfoTooltip: FunctionComponent<InfoTooltipProps> = (props: InfoTooltipProps) => {
  const [visible, setVisible] = useState(false)
  const wrapperRef = useRef(null)
  bindOutsideEvent(wrapperRef, setVisible)

  const tooltipIconSvg = props.svgIcon || infoSVG
  const iconClasses = props.iconClassName || "text-gray-800 svg-icon-s"

  return (
    <Manager>
      <Reference>
        {({ ref }) => (
          <span
            className="info-tooltip"
            data-role="info-tooltip"
            ref={ref}
            onClick={(e) => {
              setVisible(true)
            }}
          >
            <span className={iconClasses}>
              <SVG src={tooltipIconSvg} style={{}} />
            </span>
          </span>
        )}
      </Reference>
      <Popper>
        {({ ref, style, placement, arrowProps }) =>
          visible && (
            <div
              className="info-tooltip-popover"
              ref={ref}
              onClick={(e) => e.stopPropagation()}
              style={style}
              data-placement={placement}
              data-role="tooltip-content"
            >
              <div ref={wrapperRef}>
                <div className="info-tooltip-arrow" ref={arrowProps.ref} style={arrowProps.style} />
                {props.content ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: props.content,
                    }}
                  />
                ) : (
                  props.children
                )}
              </div>
            </div>
          )
        }
      </Popper>
    </Manager>
  )
}
export default InfoTooltip
